import { render } from "./ProblemsAcknowleged.vue?vue&type=template&id=7c4d59ee&scoped=true"
import script from "./ProblemsAcknowleged.vue?vue&type=script&lang=js"
export * from "./ProblemsAcknowleged.vue?vue&type=script&lang=js"

import "./ProblemsAcknowleged.vue?vue&type=style&index=0&id=7c4d59ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4d59ee"]])

export default __exports__